module.exports = __webpack_public_path__ + "static/media/ui-ux-development.754c48bb.svg";